import React from 'react'

const InfoWithIcon = ({
  className,
  icon,
  header,
  body1,
  body2,
  body3,
  reverse
}) => {
  if (reverse) {
    return (
      <div className={`row ${className}`}>
        <div className="about-us-info-text">
          <h2 className="mb-4">{header}</h2>
          <div className="about-us-info-text-body">
            <p className="mb-3">
              {body1}
            </p>
            <p className="mb-3">
              {body2}
            </p>
            <p className="mb-3">
              {body3}
            </p>
          </div>
        </div>
        <div className={icon}>
        </div>
      </div>
    )
  }
  return (
    <div className={`row ${className}`}>
    <div className={icon}>
      </div>
      <div className="about-us-info-text">
        <h2 className="mb-4">{header}</h2>
        <div className="about-us-info-text-body">
          <p className="mb-3">
            {body1}
          </p>
          <p className="mb-3">
            {body2}
          </p>
          <p className="mb-3">
            {body3}
          </p>
        </div>
      </div>
    </div>
  )
}
;

export default InfoWithIcon
